import {
  SPECTRAL_DOPPLER_TOOL_NAMES,
  type SpectralDopplerToolVariant,
} from '@/models/spectralDoppler';
import { deriveTimeValues } from './calibrationMath';
import VelocitySegmentTool from './VelocitySegmentTool';

/**
 * Time interval on a spectral Doppler strip: drawn like Slope, but
 * measures only the horizontal time between the two points.
 */
class TimeIntervalTool extends VelocitySegmentTool {
  static toolName = SPECTRAL_DOPPLER_TOOL_NAMES.TIME;

  protected variant: SpectralDopplerToolVariant = 'time';

  protected deriveValues = deriveTimeValues;
}

export default TimeIntervalTool;
